import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateBotRequestStatus = (status, botRequestId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_BOT_REQUEST_STATUS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/bot-requests/${botRequestId}`,
            { status },
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_BOT_REQUEST_STATUS_DONE',
              payload: {
                botRequestId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(botRequestId);
            }
          } else {
            dispatch({
              type: 'UPDATING_BOT_REQUEST_STATUS_FAILED',
              payload: `Failed to update bot request`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_BOT_REQUEST_STATUS_FAILED',
            payload: `Failed to update bot request`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_BOT_REQUEST_STATUS_FAILED',
        payload: `Failed to update bot request`,
      });
    }
  };
};

export default updateBotRequestStatus;
